/* eslint-disable */
export const _province = [
    {
        'id': '10',
        'type': '4',
        'content': '北京',
        'spell': 'beijing',
        'shortspell': 'bj',
        'url': 'beijing',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '39.92998577808',
        'lng': '116.39564503788',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:46:05',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:46:05',
        'deleted': '0'
    },
    {
        'id': '12',
        'type': '4',
        'content': '上海',
        'spell': 'shanghai',
        'shortspell': 'sh',
        'url': 'shanghai',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '31.249161710015',
        'lng': '121.48789948569',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:46:50',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:46:50',
        'deleted': '0'
    },
    {
        'id': '13',
        'type': '4',
        'content': '重庆',
        'spell': 'chongqing',
        'shortspell': 'cq',
        'url': 'chongqing',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '29.544606108886',
        'lng': '106.53063501341',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:47:14',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:47:14',
        'deleted': '0'
    },
    {
        'id': '14',
        'type': '2',
        'content': '河北',
        'spell': 'hebei',
        'shortspell': 'hb',
        'url': 'hebei',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '39.173148933924',
        'lng': '117.22029676508',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:47:51',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:47:51',
        'deleted': '0'
    },
    {
        'id': '15',
        'type': '2',
        'content': '山西',
        'spell': 'shanxi',
        'shortspell': 'sx',
        'url': 'shanxi',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '37.866565990509',
        'lng': '112.51549586384',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:48:19',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:48:19',
        'deleted': '0'
    },
    {
        'id': '16',
        'type': '2',
        'content': '内蒙',
        'spell': 'neimeng',
        'shortspell': 'nm',
        'url': 'neimeng',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '23.775192085865',
        'lng': '108.4115596719',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:48:44',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:48:44',
        'deleted': '0'
    },
    {
        'id': '17',
        'type': '2',
        'content': '辽宁',
        'spell': 'liaoning',
        'shortspell': 'ln',
        'url': 'liaoning',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '41.621600105958',
        'lng': '122.75359155772',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:48:58',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:48:58',
        'deleted': '0'
    },
    {
        'id': '18',
        'type': '2',
        'content': '吉林',
        'spell': 'jilin',
        'shortspell': 'jl',
        'url': 'jilin',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '43.871988334359',
        'lng': '126.56454398883',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:49:11',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:49:11',
        'deleted': '0'
    },
    {
        'id': '19',
        'type': '2',
        'content': '黑龙江',
        'spell': 'heilongjiang',
        'shortspell': 'hlj',
        'url': 'heilongjiang',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '47.356591643111',
        'lng': '128.04741371499',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:49:23',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:49:23',
        'deleted': '0'
    },
    {
        'id': '20',
        'type': '2',
        'content': '江苏',
        'spell': 'jiangsu',
        'shortspell': 'js',
        'url': 'jiangsu',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '33.013797169954',
        'lng': '119.36848893836',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:49:37',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:49:37',
        'deleted': '0'
    },
    {
        'id': '21',
        'type': '2',
        'content': '浙江',
        'spell': 'zhejiang',
        'shortspell': 'zj',
        'url': 'zhejiang',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '29.159494120761',
        'lng': '119.95720242066',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:49:51',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:49:51',
        'deleted': '0'
    },
    {
        'id': '22',
        'type': '2',
        'content': '安徽',
        'spell': 'anhui',
        'shortspell': 'ah',
        'url': 'anhui',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '31.859252417079',
        'lng': '117.21600520757',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:50:07',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:50:07',
        'deleted': '0'
    },
    {
        'id': '23',
        'type': '2',
        'content': '福建',
        'spell': 'fujian',
        'shortspell': 'fj',
        'url': 'fujian',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '26.050118295661',
        'lng': '117.98494311991',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:50:24',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:50:24',
        'deleted': '0'
    },
    {
        'id': '24',
        'type': '2',
        'content': '江西',
        'spell': 'jiangxi',
        'shortspell': 'jx',
        'url': 'jiangxi',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '27.757258443441',
        'lng': '115.6760823667',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:50:45',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:50:45',
        'deleted': '0'
    },
    {
        'id': '25',
        'type': '2',
        'content': '山东',
        'spell': 'shandong',
        'shortspell': 'sd',
        'url': 'shandong',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '36.099289929728',
        'lng': '118.52766339288',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:51:03',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:51:03',
        'deleted': '0'
    },
    {
        'id': '26',
        'type': '2',
        'content': '河南',
        'spell': 'henan',
        'shortspell': 'hn',
        'url': 'henan',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '34.511389737869',
        'lng': '101.55630729533',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:51:24',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:51:24',
        'deleted': '0'
    },
    {
        'id': '27',
        'type': '2',
        'content': '湖北',
        'spell': 'hubei',
        'shortspell': 'hb',
        'url': 'hubei',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '31.20931625014',
        'lng': '112.41056219213',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:52:41',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:52:41',
        'deleted': '0'
    },
    {
        'id': '28',
        'type': '2',
        'content': '湖南',
        'spell': 'hunan',
        'shortspell': 'hn',
        'url': 'hunan',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '27.695864052356',
        'lng': '111.72066354648',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:52:58',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:52:58',
        'deleted': '0'
    },
    {
        'id': '29',
        'type': '2',
        'content': '广东',
        'spell': 'guangdong',
        'shortspell': 'gd',
        'url': 'guangdong',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '23.408003729025',
        'lng': '113.39481755876',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:53:15',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:53:15',
        'deleted': '0'
    },
    {
        'id': '30',
        'type': '2',
        'content': '广西',
        'spell': 'guangxi',
        'shortspell': 'gx',
        'url': 'guangxi',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '23.552254688119',
        'lng': '108.92427442706',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:53:28',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:53:28',
        'deleted': '0'
    },
    {
        'id': '31',
        'type': '2',
        'content': '海南',
        'spell': 'hainan',
        'shortspell': 'hn',
        'url': 'hainan',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '39.296209479392',
        'lng': '106.92539717866',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:53:45',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:53:45',
        'deleted': '0'
    },
    {
        'id': '33',
        'type': '2',
        'content': '贵州',
        'spell': 'guizhou',
        'shortspell': 'gz',
        'url': 'guizhou',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '26.902825927797',
        'lng': '106.7349961033',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:54:18',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:54:18',
        'deleted': '0'
    },
    {
        'id': '34',
        'type': '2',
        'content': '云南',
        'spell': 'yunnan',
        'shortspell': 'yn',
        'url': 'yunnan',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '24.864212795483',
        'lng': '101.59295163701',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:54:33',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:54:33',
        'deleted': '0'
    },
    {
        'id': '35',
        'type': '2',
        'content': '西藏',
        'spell': 'xicang',
        'shortspell': 'xc',
        'url': 'xicang',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '31.367315402715',
        'lng': '89.137981684031',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:54:49',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:54:49',
        'deleted': '0'
    },
    {
        'id': '36',
        'type': '2',
        'content': '陕西',
        'spell': 'shanxi',
        'shortspell': 'sx',
        'url': 'shanxi1',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '35.860026261323',
        'lng': '109.50378929073',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:55:20',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:55:20',
        'deleted': '0'
    },
    {
        'id': '37',
        'type': '2',
        'content': '甘肃',
        'spell': 'gansu',
        'shortspell': 'gs',
        'url': 'gansu',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '38.103267343752',
        'lng': '102.45762459934',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:55:35',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:55:35',
        'deleted': '0'
    },
    {
        'id': '38',
        'type': '2',
        'content': '青海',
        'spell': 'qinghai',
        'shortspell': 'qh',
        'url': 'qinghai',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '35.499761004275',
        'lng': '96.202543672261',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:55:53',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:55:53',
        'deleted': '0'
    },
    {
        'id': '39',
        'type': '2',
        'content': '宁夏',
        'spell': 'ningxia',
        'shortspell': 'nx',
        'url': 'ningxia',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '37.321323112295',
        'lng': '106.15548126505',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:56:06',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:56:06',
        'deleted': '0'
    },
    {
        'id': '40',
        'type': '2',
        'content': '新疆',
        'spell': 'xinjiang',
        'shortspell': 'xj',
        'url': 'xinjiang',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '36.064569733063',
        'lng': '103.84993086571',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:56:21',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:56:21',
        'deleted': '0'
    },
    {
        'id': '41',
        'type': '2',
        'content': '台湾',
        'spell': 'taiwan',
        'shortspell': 'tw',
        'url': 'taiwan',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '24.086956718805',
        'lng': '121.97387097872',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:56:36',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:56:36',
        'deleted': '0'
    },
    {
        'id': '42',
        'type': '2',
        'content': '香港',
        'spell': 'xianggang',
        'shortspell': 'xg',
        'url': 'xianggang',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '22.29358599328',
        'lng': '114.18612410257',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:56:49',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:56:49',
        'deleted': '0'
    },
    {
        'id': '43',
        'type': '2',
        'content': '澳门',
        'spell': 'aomen',
        'shortspell': 'am',
        'url': 'aomen',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '22.204117988443',
        'lng': '113.55751910182',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:57:04',
        'updateuser': 'dev_archive',
        'updatetime': '2017-11-22 19:57:04',
        'deleted': '0'
    },
    {
        'id': '11',
        'type': '4',
        'content': '天津',
        'spell': 'tianjin',
        'shortspell': 'tj',
        'url': 'tianjin11',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '39.14392990331',
        'lng': '117.21081309155',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:46:25',
        'updateuser': 'szyl_admin',
        'updatetime': '2018-01-03 14:38:07',
        'deleted': '0'
    },
    {
        'id': '32',
        'type': '2',
        'content': '四川',
        'spell': 'sichuan',
        'shortspell': 'sc',
        'url': 'sichuan1',
        'areafocus': '0',
        'provincefocus': '0',
        'lat': '30.367480937958',
        'lng': '102.8991597236',
        'sort': '0',
        'status': '1',
        'createuser': 'dev_archive',
        'createtime': '2017-11-22 19:54:03',
        'updateuser': 'szyl_admin',
        'updatetime': '2018-01-03 14:41:59',
        'deleted': '0'
    }
];

